export const DragHandler = {
  extends: 'Icon',
  if: (el, s) => !el.getUserSettings('optimizedMode'),
  position: 'absolute',
  left: '50%',
  bottom: '-1.5em',
  transform: 'translate3d(-50%, 0, 1px)',
  // `name`, not `icon` — a bare `extends: 'Icon'` leaf reads its glyph off
  // `name` (see AppHeader.js LogoIcon's comment for the same footgun); the
  // stray `icon` prop here drew a permanently empty box everywhere this
  // component is used, catalog included.
  name: 'dragOutline',
  // eslint-disable-next-line no-restricted-syntax -- decorative drag-handle icon, not text
  color: 'inactive'
}
